// import { gsap } from 'gsap'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import GettingStartedSteps from '../components/get-started-steps.svelte'
import { select_option } from 'svelte/internal';
import Swiper, { Scrollbar } from 'swiper';
// gsap.registerPlugin(ScrollTrigger)

export function getTL(trigger) {
	let defaults = { opacity: 0, duration: 0.35, stagger: 0.1, ease: ' power1.out' }
	let scrollTrigger = { trigger: trigger }
	return gsap.timeline({
		defaults: defaults,
		scrollTrigger: scrollTrigger
	})
}

function partnerSlider() {
	let $partnersSlider = $('.partners-slider')
	if (!$partnersSlider.length) return

	// const tl = getTL($partnersSlider)

	$partnersSlider.slick({
		arrows: true,
		// autoplay: true,
		autoplaySpeed: 2000,
		dots: false,
		slidesToShow: 8,
		responsive: [
			{ breakpoint: 1500, settings: { slidesToShow: 6 } },
			{ breakpoint: 1200, settings: { slidesToShow: 5 } },
			{ breakpoint: 900, settings: { slidesToShow: 4 } },
			{ breakpoint: 700, settings: { slidesToShow: 3 } },
		]
	})

	$partnersSlider.click(() => {
		$partnersSlider.slick('slickNext')
	})
}

function storiesSlider() {
	let $storiesSlider = $('.stories-wrap.slick')
	if (!$storiesSlider.length) return

	// const tl = getTL($partnersSlider)

	$storiesSlider.slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 10000,
		dots: true,
		fade: true,
		slidesToShow: 1
	})
}

function partnershipStates() {
	let $tooltip = $("#tooltip");
	let $statesMap = $('.partner-states-map');

	if($statesMap.length > 0) {
		$('.enabled').hover(function () {
			const name = $(this).data('name');
			$tooltip.addClass('active');
			$tooltip.html(`${name}`);
		}, function () {
			$tooltip.removeClass('active');
		});
	
		$(document).on('mousemove', function (e) {
			$tooltip.css({
				left: e.pageX - ($statesMap.offset().left + 70),
				top: e.pageY - ($statesMap.offset().top + 60)
			});
	
		});
	}
}

//not used
export function gettingStartedSteps() {
	let $container = $('.get-started-steps')
	console.log('test')
	if (!$container.length) return

	new GettingStartedSteps({
		target: $container[0]
	})
}

function cardsGrid() {
   let $cardGrid = $('.cards-grid.overflow-scroll')
   if(!$cardGrid.length) return

   function gss() {
      const $swiperSelector = $cardGrid.find('.swiper-container');
      $swiperSelector.each(function (index) {
         const $this = $(this);
         
         let swiper
         function toggleSwiper() {
            $this.removeClass('swiper-slider-' + index);
            if(swiper) { swiper.destroy() }
            // if (x.matches) {
               $this.addClass('swiper-slider-' + index);
               swiper = new Swiper('.swiper-slider-' + index, {
                  direction: 'horizontal',
                  // effect: 'fade',
                  freeMode: false,
                  loop: false,
                  modules: [Scrollbar],
						mousewheel: true,
                  spaceBetween: 20,
						slidesPerView: 1,
                  breakpoints: {
                     0: {
                       slidesPerView: 1
                     },
                     576: {
                       slidesPerView: 2
                     },
                     1280: {
                       slidesPerView: 3
                     },
                  },
                  // slidesPerView: 1,
                  scrollbar: {
                     el: '.swiper-scrollbar',
                     draggable: true,
                     dragSize: 'auto'
                  },
                  watchOverflow: true,
               });
   
               //! jquery app
               $(swiper).on('slideChange', function () {
                  console.log(this.activeIndex + 1);
               });
            // } 
            // else {
            //    $this.removeClass('swiper-slider-' + index);
            //    if(swiper) { swiper.destroy() }
            // }
         }
   
         // let x = window.matchMedia('(min-width: 250px)');
         toggleSwiper()//x)
         // x.addListener(toggleSwiper)
      });
   }
   gss()
}

export function gettingStartedSlider() {
   const $stepsSlider = $('.gs-steps');
   if (!$stepsSlider.length) return


   $stepsSlider.slick({
      arrows: false,
      slidesToShow: 1,
      fade: true, //!?
      speed: 200,
      infinite: false
   })
   
   let $steps = $('.gs-step-nums li')
   let activeIdx = 0
   $steps[activeIdx].classList.add('active')
   $stepsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      activeIdx = (nextSlide ? nextSlide : 0);
      $steps.removeClass('active')
      $steps[activeIdx].classList.add('active')
   });
   $steps.each((idx, el) => $(el).click(() => {
      $steps.removeClass('active')
      $stepsSlider.slick('slickGoTo', idx)
      $(el).addClass('active')
   }))

   $('.gs-steps').click(() => $stepsSlider.slick('slickNext'))
}

function animateWhitepaperForm() {
	if(!$('.block-whitepaper--form').length) { return; }
}

/**
 * Testimonial Slider Block
 */

function testimonialSlider() { //first found on for schools page
	function staggerTestimony() {
		var textWrapper = $testimonialSlider.find('.slick-current p:first-child')[0]
		// textWrapper.innerHTML = textWrapper.textContent.replace(/\S+/g, "<span class='word'>$&</span>")
		// gsap.set($(textWrapper).find('.word'), { y: 16, x: 0, rotateZ: 0 })
		gsap.set($(textWrapper), { opacity: 0, y: 16, x: 0, rotateZ: 0 })
		gsap.set($testimonialSlider.find('cite'), { y: 16, opacity: 0 })
		tl.to(
			$(textWrapper),//.find('.word'),
			{
				rotateZ: 0,
				// stagger: 0.02,
				// duration: 0.15,
				duration: 0.35,
				y:0,
				ease:'power1.out',
				opacity: 1
			}
		)
		tl.to($testimonialSlider.find('cite'), { opacity: 1, y:0, duration: 0.5, ease:'power1.out'})
	}

	const $testimonialSlider = $('.testimonial-slider')
	if (!$testimonialSlider.length || $testimonialSlider.find('.testimonial').length < 2) {
		return
	}
	// const tl = gsap.timeline({
	// 	defaults: { 
	// 		duration: 0.35,
	// 		opacity: 1,
	// 		stagger: 0.1,
	// 		x: 0,
	// 		y: 0,
	// 		ease: "power1.out"
	// 	},
	// 	scrollTrigger:{trigger:$testimonialSlider, start: 'center bottom'}
	// })

	$testimonialSlider.slick({
		adaptiveHeight: true,
		arrows: false,
		dots: true,
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
	})
	
	//onload
	// staggerTestimony(tl)

	$testimonialSlider.click(() => {
		$testimonialSlider.slick('slickNext')
	})
}

/**
 * Blog
 */
function blogAnimate() {
	let $inPageNav = $('.cat-nav')
	if(!$inPageNav.length) {
		return
	}
	gsap.from($inPageNav.find('li'), {
		scrollTrigger: { 
			trigger: $inPageNav
		}, 
		duration: 0.35,
		ease:'power1.out',
		opacity: 0,
		stagger: 0.1,
		x:16,
	})	

	let $featured = $('.featured-posts')
	if(!$featured.length) {
		$featured = $('.child-category .child-category--title')
	}
	if($featured.length) {
		gsap.from($featured, {
			scrollTrigger: { 
				trigger: $featured
			}, 
			opacity: 0,
			duration: 0.35,
			ease:'power1.out',
			y:32,
		})		
	}

	if($('.child-category .child-category--title').length) {
		gsap.from($('.post-cards--grid-wrap'), {
			scrollTrigger: { 
				trigger: $('.post-cards--grid-inner')
			}, 
			duration: 0.35,
			ease:'power1.out',
			opacity: 0,
			stagger: 0.1,
			y:16
		})
	}


	$('.sub-category-posts--title').each((idx, el) => {
		gsap.from(el, {
			scrollTrigger: { 
				trigger: el,
				start: 'top 90%'
			}, 
			opacity: 0,
			duration: 0.35,
			ease:'power1.out',
			y:-16,
		})	
	})
	$('.sub-category-posts--title + .post-cards--single').each((idx, el) => {
		gsap.from(el, {
			scrollTrigger: { 
				trigger: el,
				start: 'top 90%'
			}, 
			opacity: 0,
			duration: 0.35,
			ease:'power1.out',
			y:16,
		})	
	})
}

function animateWPMediaText() {
	let $WPMT = $('.wp-block-media-text')
	if(!$WPMT.length) { return }

	$WPMT.each((idx, el) => {
		gsap.from(el, {
			delay: 0.2,
			opacity: 0,
			ease: 'power1.out',
			scrollTrigger: {
				trigger: el,
				start: 'top 90%'
			}
		})
	})
}

function animateWPButtonLink() {
	let $WPBL = $('.wp-block-button__link')
	if(!$WPBL.length) { return }

	$WPBL.each((idx, el) => {
		gsap.from(el, {
			delay: 0.2,
			opacity: 0,
			ease: 'power1.out',
			scrollTrigger: {
				trigger: el,
				start: 'top 90%'
			}
		})
	})
}

function animateError404() {
	if (!$('.error404').length) {
		return
	}
	const tl = gsap.timeline({
		defaults: {
			duration: 0.5,
			opacity: 0,
		},
		// scrollTrigger:{trigger:'.call-to-action'}
	})

	tl.from('h1', { delay: 0.5, y: -16 })
	tl.from('h1 ~ p', { y: 16 }, '-=0.5')
	tl.from('h1 ~ .btn', {}, '-=0.2')
}

function animateCTA() {
	let $cta = $('.call-to-action')
	if(!$cta.length) {
		$cta = $('.swing-newsletter')
	}
	if (!$cta.length) {
		return
	}
	const tl = gsap.timeline({
		defaults: { opacity: 0, duration: 0.2, ease: 'power1.out' },
		scrollTrigger: {
			trigger: $cta,
			start: 'center 90%',
			// markers: true,
			toggleActions: 'play none none reverse'
		}
	})

	var textWrapper = $cta.find('h2 .letters')[0]
	textWrapper.innerHTML = textWrapper.textContent.replace(/\S+/g, "<span class='word'>$&</span>")
	gsap.set($cta.find('.word'), { opacity: 0, y: 24 })
	tl.to(
		$cta.find('.word'),
		{
			y: 0,
			// delay: 0.25,
			duration: 0.5,
			ease: "elastic.out(1,0.5)",
			stagger: 0.05,
			opacity: 1
		})
	// .from($cta.find('.btns-wrap'), { y: 32 })
}

function animateFooter() {
	const tl = gsap.timeline({
		defaults: { opacity: 0, ease: 'power1.out', duration: 0.35, stagger: 0.1 },
		scrollTrigger: { trigger: 'footer' }
	})

	tl.from('footer > .main', { duration: 0.65, delay: 0.2 })
	gsap.from('footer .social-icon', { y: 16, opacity: 0, ease: 'power1.out', duration: 0.3, stagger: 0.2, scrollTrigger: { trigger: '.footer-social-icons', start: 'center bottom' } })
	$('.footer-links .col').each((_idx, el) => {
		gsap.set($(el).children(), { y: 16, opacity: 0 })
		gsap.to($(el).children(), { delay: 0.2 + 0.1 * _idx, scrollTrigger: { trigger: el, start: 'center bottom' }, y: 0, opacity: 1, ease: 'power1.out', duration: 0.2, stagger: 0.1 })
	})
}


function postSlider() {
	const $postSlider = $('.post-cards--grid.slick ul');

	if (!$postSlider.length) return

	const $slides = $('.post-cards--grid.slick ul li');

	if (!$postSlider.length) {
		return
	}

	if ($slides.length > 1) {
		$postSlider.slick({
			arrows: false,
			dots: true,
			slidesToShow: 1,
		})
	}
}


function featuredPostsSlider() {
	const $swiperSelector = $('.swiper-container');

	$swiperSelector.each(function (index) {
		const $this = $(this);
		
		let swiper
		function toggleSwiper() {
			if (x.matches) {
				$this.addClass('swiper-slider-' + index);
				swiper = new Swiper('.swiper-slider-' + index, {
					modules: [Scrollbar],
					direction: 'horizontal',
					loop: false,
					freeMode: false,
					watchOverflow: true,
					spaceBetween: 20,
					slidesPerView: 1,
					scrollbar: {
						el: '.swiper-scrollbar',
						draggable: true,
						dragSize: 80
					}
				});
			} 
			else {
				$this.removeClass('swiper-slider-' + index);
				if(swiper) { swiper.destroy() }
			}
		}

		let x = window.matchMedia('(max-width: 767px)');
		toggleSwiper(x)
		x.addListener(toggleSwiper)
	});
}


/**
 * Step Slider
 */
function stepSlider() { //single Job post

	const $stepSlider = $('.step-slider .slider');
	const $stepSliderNav = $('.step-slider .ss-nav');
	
	const $swiperSelector = $('.swiper-container');
	
	$swiperSelector.each(function (index) {
		const $this = $(this);
		$this.addClass('swiper-slider-' + index);
	
		const swiper = new Swiper('.swiper-slider-' + index, {
			modules: [Scrollbar],
			direction: 'horizontal',
			loop: false,
			freeMode: false,
			watchOverflow: true,
			spaceBetween: 20,
			slidesPerView: 1,
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
				dragSize: 80
			}
		});
	});

	if (!$stepSlider.length) {
		return
	}

	$stepSlider.slick({
		arrows: false,
		dots: false,
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
	});

	$($stepSliderNav).find('a[data-slide]').click(function (e) {
		e.preventDefault();
		let slideno = $(this).data('slide');
		$stepSlider.slick('slickGoTo', slideno - 1);
	});

}


/**
 * Text Cards Rotator Block
 */
function textCardsBlock() { //first found on for subs page under hero
	const $textCards = $('.text-cards-rotator .cards.slick')
	if (!$textCards.length) {
		return
	}

	$textCards.slick({
		arrows: false,
		dots: false,
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 6000,
		pauseOnHover: true,
		pauseOnDotsHover: true
	})

	$textCards.on('click', function() {
		$textCards.slick('slickNext')
	})

	let $dots = $('.slick-dots li')
	let numSlides = $('.tcr-cards + ul.slick-dots li').length
	$dots.each((idx, el) => {
		$(el).click(function () {
			// console.log(idx)
			// $textCards.slick('slickNext')
			$textCards.slick('slickGoTo', idx)
			// console.log(Math.abs($textCards.slick('slickCurrentSlide') - idx))
			// for(let i = 0; i < Math.abs($textCards.slick('slickCurrentSlide') - idx); i++) {
			// 	console.log(i)
			// 	setTimeout(() => {
			// 		$textCards.slick('slickNext')
			// 	}, i*100)
			// }
		})
	})
	
	$textCards.on('beforeChange', () => { //beforeChange not to work with skipIndex dot navigation cur: 1 goTo 3
		let absIdx = ($textCards.slick('slickCurrentSlide') + 1) % numSlides
		// let absIdx = ($textCards.slick('slickCurrentSlide')) % numSlides
		// console.log(absIdx)
		$dots.removeClass('slick-active')
		$dots.find('button').attr('aria-selected', false)
		// let activeIdx = $textCards.slick('slickCurrentSlide')
		//desktop
		$dots[absIdx].classList.add('slick-active')
		$($dots[absIdx]).find('button').attr('aria-selected', true)
		//mobile
		$dots[absIdx + numSlides].classList.add('slick-active')
		$($dots[absIdx + numSlides]).find('button').attr('aria-selected', true)
	})
	$textCards.on('afterChange', () => { //beforeChange not to work with skipIndex dot navigation cur: 1 goTo 3
		// let absIdx = ($textCards.slick('slickCurrentSlide') + 1) % numSlides
		let absIdx = ($textCards.slick('slickCurrentSlide')) % numSlides
		// console.log(absIdx)
		$dots.removeClass('slick-active')
		$dots.find('button').attr('aria-selected', false)
		// let activeIdx = $textCards.slick('slickCurrentSlide')
		//desktop
		$dots[absIdx].classList.add('slick-active')
		$($dots[absIdx]).find('button').attr('aria-selected', true)
		//mobile
		$dots[absIdx + numSlides].classList.add('slick-active')
		$($dots[absIdx + numSlides]).find('button').attr('aria-selected', true)
	})
}

function helpfulArticles() {
	let $articles = $('.ha-wrap.grid-three')
	if (!$articles.length || !$('.helpful-articles').length) return
	// const tl = gsap.timeline({
	// 	defaults: { opacity: 0, stagger: 0.1, duration: 0.35, ease: 'power1.out' },
	// 	scrollTrigger: {
	// 		trigger: '.helpful-articles',
	// 		start: 'top bottom-=200'
	// 	}
	// })

	let slider, x = window.matchMedia('(max-width: 767px)') //md
	x.addListener(haSlider)
	haSlider(x)

	function haSlider(x) {
		if (x.matches) {
			slider = $articles.slick({
				slidesToShow: 1,
				fade: true,
				dots: true,
				arrows: false
			})
			// $('.ha-wrap .slick-track').each((_idx, el) => {
			// 	gsap.set(el, { y: 24, opacity: 0 })
			// 	gsap.to(el, { opacity: 1, y: 0, delay: 0.35, scrollTrigger: { trigger: el, start: 'center bottom' } })
			// })
		} else {
			if (slider) {
				$articles.slick('unslick')
			}
			slider = null

			// $('.ha-wrap .grid-item').each((idx, el) => {
			// 	gsap.set(el, { y: 24, opacity: 0 })
			// 	gsap.to(el, { opacity: 1, y: 0, delay: 0.2*idx, ease:'power1.out', scrollTrigger: { trigger: el, start: 'center bottom' } })
			// })
		}
	}

	// if ($('.helpful-articles h2').length) {
	// 	var textWrapper = $('.helpful-articles h2 .letters')[0]
	// 	textWrapper.innerHTML = textWrapper.textContent.replace(/\S+/g, "<span class='word'>$&</span>")
	// 	gsap.set($('.helpful-articles h2 .word'), { opacity: 0, y: 24 })
	// 	tl.to('.helpful-articles h2 .word',
	// 		{
	// 			y: 0,
	// 			delay: 0.25,
	// 			duration: 0.65,
	// 			ease: "elastic.out(1,0.5)",
	// 			opacity: 1,
	// 			stagger: 0.05
	// 		})
	// }
	// if ($('.whitepaper-section').length) {
	// 	gsap.fromTo('.whitepaper-section', { y: 24, opacity: 0 }, { opacity: 1, y: 0, scrollTrigger: { trigger: '.whitepaper-section', start: 'center bottom' } })
	// }
}

function animateTextCardRotator() {
   let $container = $('.text-cards-rotator')
   if(!$container.length)return

   $('.text-cards-rotator').each((_idx, el) => {
      const tl = gsap.timeline({
         defaults: { opacity: 0, ease:'power1.out', duration: 0.35, stagger: 0.1},
         scrollTrigger: {trigger: el, start: 'center bottom'} //mobile
      })

      var textWrapper = $(el).find('h2 .letters')[0]
      textWrapper.innerHTML = textWrapper.textContent.replace(/\S+/g, "<span class='word'>$&</span>")
      gsap.set($(el).find('.word'), {opacity: 0, y: 24, x: 0, rotateZ: 0})
      tl.to(
         $(el).find('.word'),
         {
            y:0,
            delay: 0.25,
            duration: 0.65,
            ease: "elastic.out(1,0.5)",
            stagger: 0.05,
            opacity: 1
         })
         .from(
            $(el).find('h2 ~ p'),
            {
               y: 16,
               // duration: 0.2
            },
            '-=0.85'
         )
         .from(
            $(el).find('.slick-dots'),
            {
               x: 32,
               duration: 0.2
            },
            '-=0.85'
         )
         .from(
            $(el).find('.tcr-cards'),
            {
               y: 32,
            },
            '-=0.85'
         )
   })
}


function getStartedGrid() {
	
}

export {
	animateWhitepaperForm,
	animateWPMediaText,
	animateWPButtonLink,
	blogAnimate,
	testimonialSlider,
	animateTextCardRotator,

	textCardsBlock,
	helpfulArticles,
	partnerSlider,
	storiesSlider,
	cardsGrid,
	partnershipStates,

	animateError404,
	animateCTA,
	animateFooter,

	postSlider,
	featuredPostsSlider
}
